import { render, staticRenderFns } from "./CashbackDetail.vue?vue&type=template&id=4a84fdbc&"
import script from "./CashbackDetail.vue?vue&type=script&lang=js&"
export * from "./CashbackDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports